// Recipient suggestions must be deliverable email addresses, never contact UUIDs.
// Legacy callers may provide the email as id rather than a separate email field.
const text = (value) => String(value ?? '').trim();
const isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text(value));

export const normalizeRecipientContact = (entry) => {
  if (!entry) return null;
  if (typeof entry === 'string') {
    const email = text(entry);
    return isEmail(email) ? { id: email, email, name: email } : null;
  }
  if (typeof entry !== 'object' || entry.mergedIntoContactId) return null;

  const email = text(entry.email || entry.id);
  if (!isEmail(email)) return null;

  const name = text(entry.name || `${entry.firstName || ''} ${entry.lastName || ''}`) || email;
  return { ...entry, id: email, email, name };
};

export const buildRecipientContactOptions = (contacts = []) => {
  const seenEmails = new Set();
  return (Array.isArray(contacts) ? contacts : []).reduce((options, entry) => {
    const contact = normalizeRecipientContact(entry);
    if (!contact) return options;

    const emailKey = contact.email.toLowerCase();
    if (!seenEmails.has(emailKey)) {
      seenEmails.add(emailKey);
      options.push(contact);
    }
    return options;
  }, []);
};
